import { render } from "./Merchants.vue?vue&type=template&id=1878d7f3&ts=true"
import script from "./Merchants.vue?vue&type=script&lang=ts"
export * from "./Merchants.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__